var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnAuthenticated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "114px",
    viewBox: "0 0 100 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "component_\\u4F5C\\u696D\\u7528",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6A29\\u9650\\u30A8\\u30E9\\u30FC",
    transform: "translate(-540.000000, -102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-/-error",
    transform: "translate(540.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0688108,20.9809211 L89.9760915,52.8814278 L89.9760915,112.372747 L1.51615416,112.372747 L2.15336558,52.8873597 L46.0688108,20.9809211 Z",
    id: "Polygon",
    stroke: "#8DA7B5",
    strokeWidth: 3,
    fill: "#C7D9E8",
    transform: "translate(45.738046, 66.499783) scale(1, -1) translate(-45.738046, -66.499783) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0387413,25.1389253 L85.8180873,54.0403119 L85.8180873,107.085884 L5.67440251,107.085884 L6.25110822,54.0463327 L46.0387413,25.1389253 Z",
    id: "Polygon",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    transform: "translate(45.738046, 65.935354) scale(1, -1) translate(-45.738046, -65.935354) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "account_circle_black_24dp-(1)",
    transform: "translate(22.453222, 32.432432)",
    fill: "#007DB5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7006237,0 C30.3728344,0 35.7588358,5.38600139 35.7588358,12.0582121 C35.7588358,18.7304227 30.3728344,24.1164241 23.7006237,24.1164241 C17.028413,24.1164241 11.6424116,18.7304227 11.6424116,12.0582121 C11.6424116,5.38600139 17.028413,0 23.7006237,0 Z M23.7006237,56.5488565 C13.8253638,56.5488565 5.0956341,51.4800515 0,43.7976438 C0.118503119,35.9172359 15.8004158,31.6008316 23.7006237,31.6008316 C31.5613306,31.6008316 47.2827443,35.9172359 47.4012474,43.7976438 C42.3056133,51.4800515 33.5758836,56.5488565 23.7006237,56.5488565 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8DA7B5",
    strokeWidth: 3,
    cx: 81.0810811,
    cy: 11.2266112,
    r: 9.72661123
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8DA7B5",
    strokeWidth: 3,
    fill: "#C7D9E8",
    x: 63.0384615,
    y: 12.3108108,
    width: 35.4615385,
    height: 26.1060291,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(75.675676, 18.295218)",
    fill: "#007DB5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.98960499,
    cy: 4.98960499,
    r: 4.98960499
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.49480249,
    y: 4.98960499,
    width: 4.98960499,
    height: 9.14760915,
    rx: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAuthenticated);
export default __webpack_public_path__ + "static/media/unAuthenticated.ffc99125c1bce438a9c21f1f82ce8881.svg";
export { ForwardRef as ReactComponent };